/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { TeamMemberFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateTeamMemberInput = {
  email: string
  role: string
}

export type UpdateTeamMemberInput = {
  email?: string | null
  id: string
  role?: string | null
}

export type CreateTeamMemberMutationVariables = Exact<{
  teamID: string
  input: Types.CreateTeamMemberInput
}>

export type CreateTeamMemberMutation = {
  __typename: "Mutation"
  teamMember: {
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }
}

export type UpdateTeamMemberMutationVariables = Exact<{
  teamID: string
  teamMemberID: string
  input: Types.UpdateTeamMemberInput
}>

export type UpdateTeamMemberMutation = {
  __typename: "Mutation"
  teamMember: {
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }
}

export type DeleteTeamMemberMutationVariables = Exact<{
  teamID: string
  teamMemberID: string
}>

export type DeleteTeamMemberMutation = {
  __typename: "Mutation"
  teamMember: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateTeamMemberDocument = gql`
  mutation CreateTeamMember($teamID: ID!, $input: CreateTeamMemberInput!) {
    teamMember: createTeamMember(teamID: $teamID, input: $input)
      @rest(
        type: "TeamMember"
        method: "POST"
        path: "/project-list/teams/{args.teamID}/members"
        bodySerializer: "teamMember"
      ) {
      ...TeamMember
    }
  }
  ${TeamMemberFragmentDoc}
`
export type CreateTeamMemberMutationFn = Apollo.MutationFunction<
  CreateTeamMemberMutation,
  CreateTeamMemberMutationVariables
>

/**
 * __useCreateTeamMemberMutation__
 *
 * To run a mutation, you first call `useCreateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMemberMutation, { data, loading, error }] = useCreateTeamMemberMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTeamMemberMutation,
    CreateTeamMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateTeamMemberMutation,
    CreateTeamMemberMutationVariables
  >(CreateTeamMemberDocument, options)
}
export type CreateTeamMemberMutationHookResult = ReturnType<
  typeof useCreateTeamMemberMutation
>
export type CreateTeamMemberMutationResult =
  Apollo.MutationResult<CreateTeamMemberMutation>
export type CreateTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  CreateTeamMemberMutation,
  CreateTeamMemberMutationVariables
>
export const UpdateTeamMemberDocument = gql`
  mutation UpdateTeamMember(
    $teamID: ID!
    $teamMemberID: ID!
    $input: UpdateTeamMemberInput!
  ) {
    teamMember: updateTeamMember(
      teamID: $teamID
      teamMemberID: $teamMemberID
      input: $input
    )
      @rest(
        type: "TeamMember"
        method: "PUT"
        path: "/project-list/teams/{args.teamID}/members/{args.teamMemberID}"
        bodySerializer: "teamMember"
      ) {
      ...TeamMember
    }
  }
  ${TeamMemberFragmentDoc}
`
export type UpdateTeamMemberMutationFn = Apollo.MutationFunction<
  UpdateTeamMemberMutation,
  UpdateTeamMemberMutationVariables
>

/**
 * __useUpdateTeamMemberMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMemberMutation, { data, loading, error }] = useUpdateTeamMemberMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamMemberID: // value for 'teamMemberID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTeamMemberMutation,
    UpdateTeamMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateTeamMemberMutation,
    UpdateTeamMemberMutationVariables
  >(UpdateTeamMemberDocument, options)
}
export type UpdateTeamMemberMutationHookResult = ReturnType<
  typeof useUpdateTeamMemberMutation
>
export type UpdateTeamMemberMutationResult =
  Apollo.MutationResult<UpdateTeamMemberMutation>
export type UpdateTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  UpdateTeamMemberMutation,
  UpdateTeamMemberMutationVariables
>
export const DeleteTeamMemberDocument = gql`
  mutation DeleteTeamMember($teamID: ID!, $teamMemberID: ID!) {
    teamMember: deleteTeamMember(teamID: $teamID, teamMemberID: $teamMemberID)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/teams/{args.teamID}/members/{args.teamMemberID}"
        bodySerializer: "teamMember"
      ) {
      success
    }
  }
`
export type DeleteTeamMemberMutationFn = Apollo.MutationFunction<
  DeleteTeamMemberMutation,
  DeleteTeamMemberMutationVariables
>

/**
 * __useDeleteTeamMemberMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMemberMutation, { data, loading, error }] = useDeleteTeamMemberMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamMemberID: // value for 'teamMemberID'
 *   },
 * });
 */
export function useDeleteTeamMemberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteTeamMemberMutation,
    DeleteTeamMemberMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteTeamMemberMutation,
    DeleteTeamMemberMutationVariables
  >(DeleteTeamMemberDocument, options)
}
export type DeleteTeamMemberMutationHookResult = ReturnType<
  typeof useDeleteTeamMemberMutation
>
export type DeleteTeamMemberMutationResult =
  Apollo.MutationResult<DeleteTeamMemberMutation>
export type DeleteTeamMemberMutationOptions = Apollo.BaseMutationOptions<
  DeleteTeamMemberMutation,
  DeleteTeamMemberMutationVariables
>
